import React from "react";

import useStyles from "@hooks/useStyles";

import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import Box from "@material-ui/core/Box";

import Avatar from "@material-ui/core/Avatar";
import MonetizationOnOutlinedIcon from "@material-ui/icons/MonetizationOnOutlined";
import EventAvailableIcon from "@material-ui/icons/EventAvailable";
import DesktopMacIcon from "@material-ui/icons/DesktopMac";
import LineBreak from "@components/Global/Custom/Icons/LineBreak";

import Link from "@material-ui/core/Link";

import LocationOnOutlinedIcon from "@material-ui/icons/LocationOnOutlined";
import CallIcon from "@material-ui/icons/Call";

const WebsiteLocationHours = ({ isDialog }) => {
	const classes = useStyles("Website");

	const backgroundColor = ""; // #ffebe5
	const backgroundGradient = ``; // for testing  linear-gradient(121.04deg,#79dfff 15.69%,#865cff)
	const backgroundImage = ``; // for testing https://wallpapercave.com/wp/wp8377155.jpg
	const coloredBox = false;

	const header = `Location & hours`;
	const subHeader = ``;
	const tagline = "";
	const textAlign = "right";
	const lineBreak = false;
	const content = "";

	// const button = "";
	// const buttonLink = "/wesbite/about-us";

	const daysOfWeek = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
	const hourSlots = [
		"9 AM – 5 PM",
		"9 AM – 5 PM",
		"9 AM – 5 PM",
		"9 AM – 5 PM",
		"9 AM – 5 PM",
		"Closed",
		"Closed",
	];

	return (
		<React.Fragment>
			<section
				className={
					tagline || header || subHeader || lineBreak || content
						? "websiteComponent"
						: "websiteComponent thin"
				}
				style={{
					backgroundColor:
						!coloredBox && backgroundColor ? backgroundColor : "unset",
					backgroundImage:
						!coloredBox && backgroundGradient ? backgroundGradient : "unset",
				}}
			>
				{backgroundImage && (
					<Box
						position={"absolute"}
						top={0}
						bottom={0}
						width={"100%"}
						style={{
							backgroundImage: `url(${backgroundImage})`,
							backgroundRepeat: "no-repeat",
							backgroundSize: "cover",
							backgroundPosition: "50% 50%",
							opacity: "0.4",
							//filter: "blur(2px)",
						}}
						zIndex={1}
					/>
				)}

				<Container maxWidth={"lg"} disableGutters style={{ zIndex: 3 }}>
					<div
						className={coloredBox ? classes.featuredTextBox : undefined}
						style={{
							backgroundColor:
								coloredBox && backgroundColor ? backgroundColor : "",
							backgroundImage:
								coloredBox && backgroundGradient ? backgroundGradient : "unset",
						}}
					>
						<Grid
							container
							spacing={8}
							direction={textAlign === "left" ? "row" : "row-reverse"}
						>
							<Grid item xs={12} sm={12} md={isDialog ? 12 : 6}>
								<Box
									display={"flex"}
									flexDirection={"column"}
									justifyContent={"center"}
									height={"100%"}
									m={
										textAlign === "left"
											? { xs: 0, sm: "0px 40px 0px 0px" }
											: { xs: 0, sm: "0px 0px 0px 40px" }
									}
								>
									{tagline && <div className="tagline">{tagline}</div>}

									{header && (
										<Box component={"h2"}>
											{header ? header : "Location & hours"}
										</Box>
									)}

									{subHeader && <Box component={"h3"}>{subHeader}</Box>}

									{lineBreak && (
										<Box my={1}>
											<LineBreak className={classes.lineBreak} />
										</Box>
									)}

									{content && (
										<>
											<Box component={"p"}>{content}</Box>
										</>
									)}
									{/* <Box
									display="flex"
									flexDirection="column"
									style={{ gap: 8 }}
									mt={8}
								>
									<Box fontWeight={600}>Lmnop Children's Academy</Box>

									<div>2808 TRINITY SQUARE DR</div>
									<div>Carrollton, TX 75006</div>
								</Box> */}

									<Box mt={8}>
										<Grid container spacing={6}>
											<Grid item xs={12}>
												<Box display={"flex"} style={{ gap: 12 }}>
													<LocationOnOutlinedIcon />
													<Box
														display={"flex"}
														flexDirection={"column"}
														style={{ gap: 4 }}
													>
														<Box fontWeight={600}>
															Barton Creed Child Development Center
														</Box>
														<div>51540 Romeo Plank</div>
														<div>Macomb, MI 48042</div>
														<Box mt={4}>
															<Button
																color="primary"
																variant="contained"
																disableElevation
																href="dir"
																size="large"
																className="columnButton"
															>
																Get directions
															</Button>
														</Box>
													</Box>
												</Box>
											</Grid>

											<Grid item xs={12}>
												<Box display={"flex"} style={{ gap: 12 }}>
													<CallIcon />

													<Link
														href="/"
														style={{ fontWeight: 600 }}
														color="secondary"
													>
														(832) 775-9938
													</Link>
												</Box>
											</Grid>
										</Grid>
									</Box>

									<Box display={"flex"} justifyContent={"space-between"} mt={8}>
										<Box display={"flex"} flexDirection={"column"} width={110}>
											{daysOfWeek.map((day, index) => (
												<div
													key={`day-${index}`}
													className={classes.hoursDialogDay}
												>
													{index === 0 ? <strong>{day}</strong> : day}
												</div>
											))}
										</Box>
										<Box
											display={"flex"}
											flexGrow={1}
											justifyContent={"space-between"}
										>
											<Box
												display={"flex"}
												flexDirection={"column"}
												width={175}
											>
												{hourSlots.map((hour, index) => (
													<div
														key={`hours-${index}`}
														className={classes.hoursDialogTime}
													>
														{index === 0 ? (
															<strong>
																<div
																	dangerouslySetInnerHTML={{ __html: hour }}
																/>
															</strong>
														) : (
															<div dangerouslySetInnerHTML={{ __html: hour }} />
														)}
													</div>
												))}
											</Box>
										</Box>
									</Box>

									{/* {button && (
									<Box mt={8}>
										<Button
											size="large"
											color="primary"
											variant="contained"
											disableElevation
											href={buttonLink}
										>
											{button}
										</Button>
									</Box>
								)} */}
								</Box>
							</Grid>

							<Grid item xs={12} sm={12} md={isDialog ? 12 : 6}>
								<Box
									width={"100%"}
									height={"100%"}
									display={"inline-block"}
									borderRadius={4}
								>
									<a href="directions" target="_blank">
										<Box
											component={"img"}
											minHeight={isDialog ? "unset" : "70vh"}
											width={"100%"}
											className="picture"
											src="https://api.mapbox.com/styles/v1/mattydyer/cltpzx1v200ah01qwe36zhw6c/static/pin-l+0D1619(-97.73884582519531,30.322032928466797)/-97.73884582519531,30.322032928466797,13,0/800x800@2x?access_token=pk.eyJ1IjoibWF0dHlkeWVyIiwiYSI6ImNsZGoxNGU2eTA0M24zb2t3ZXZvYWRod24ifQ.GYW7sqkNhyIqGKmaqDE5sQ"
											//replace with the map we use with the outlines / radius around city
										/>
									</a>
								</Box>
							</Grid>
						</Grid>
					</div>
				</Container>
			</section>
		</React.Fragment>
	);
};

export default WebsiteLocationHours;
